export default function ({ redirect, $auth, route, from }) {
  if (!$auth.loggedIn) {
    return redirect(`/?remember_url=${route.fullPath}`);
  }
}
